import holidayHoursAtom from "@/atoms/holiday-hours"
import merchantStatusAtom from "@/atoms/merchant-status"
import takeoutServiceAtom from "@/atoms/takeout-service"
import { isMerchantClosed } from "@/lib/is-merchant-closed"
import { ApiData } from "@/types"
import { useSetAtom } from "jotai"
import { useEffect } from "react"
import ApiHydration from "./ApiHydration"
import IndoorApiHydration from "./IndoorApiHydration"

export default function ApiCache({ data, children }: {
  data: ApiData | null
  children: React.ReactNode
}) {
  const setHolidayHours = useSetAtom(holidayHoursAtom)
  const setMerchantStatus = useSetAtom(merchantStatusAtom)
  const setTakeoutService = useSetAtom(takeoutServiceAtom)

  useEffect(() => {
    if (!data) return
    setHolidayHours(isMerchantClosed(data))
    setMerchantStatus(data.status)
    setTakeoutService(data.services.find((s) => s.serviceType === "TAKEOUT") ?? null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  if (!data) return null

  return (
    <IndoorApiHydration data={data}>
      <ApiHydration data={data}>
        {children}
      </ApiHydration>
    </IndoorApiHydration>
  )
}
